// extracted by mini-css-extract-plugin
export var printerCard = "_b4-1";
export var printerCardConfigured = "_b4-2";
export var printerCardError = "_b4-3";
export var printerCardsContainer = "_b4-0";
export var printerIcon = "_b4-8";
export var printerIconConfigured = "_b4-5";
export var printerIconContainer = "_b4-4";
export var printerIconError = "_b4-6";
export var printerIconUnconfigured = "_b4-7";
export var workstationsTableCard = "_b4-9";